import { useCallback } from "react";
import { ExtractedContract } from "../../types/contract";

export const useFieldControl = (
  currentResolution: { building: "keep" | "update" | null; owner: "keep" | "update" | null } | null
) => {
  // フィールドがdisabledかどうかを判定
  const isFieldDisabled = useCallback(
    (field: keyof ExtractedContract): boolean => {
      if (!currentResolution) return false;

      // 建物関連フィールド
      const buildingFields: (keyof ExtractedContract)[] = [
        "property_name",
        "property_address",
        "property_address2",
        "property_postal_code",
        "building_code",
        "building_name_kana",
      ];
      if (buildingFields.includes(field)) {
        return currentResolution.building === "keep";
      }

      // 家主関連フィールド
      const ownerFields: (keyof ExtractedContract)[] = [
        "owner_name",
        "owner_name_kana",
        "owner_type",
        "owner_company_name",
        "owner_postal_code",
        "owner_address1",
        "owner_address2",
        "owner_home_phone",
        "owner_mobile_phone",
        "owner_bank_1_branch_code",
        "owner_bank_1_account_type",
        "owner_bank_1_account_number",
        "owner_bank_1_account_holder_name",
        "owner_bank_2_branch_code",
        "owner_bank_2_account_type",
        "owner_bank_2_account_number",
        "owner_bank_2_account_holder_name",
      ];
      if (ownerFields.includes(field)) {
        return currentResolution.owner === "keep";
      }

      return false;
    },
    [currentResolution],
  );

  return {
    isFieldDisabled,
  };
};